import {
  getFaithReconnectSteps,
  getFamilyDevotionalSteps
} from "./flowData";
import type { FunnelDefinition, FunnelId } from "./types";

export const DEFAULT_FUNNEL_ID = "faith-reconnect" satisfies FunnelId;

export const FUNNEL_DEFINITIONS: FunnelDefinition[] = [
  {
    id: "faith-reconnect",
    slug: "faith",
    name: "Faith Reconnect",
    aliases: ["faith", "faith-reconnect", "reconnect", "bible", "default"],
    defaultVariant: "a",
    theme: {
      id: "faith",
      className: "faith"
    },
    getSteps: getFaithReconnectSteps
  },
  {
    id: "family-devotional",
    slug: "family",
    name: "Family Devotional",
    aliases: ["family", "family-devotional", "family-devotion", "devotional"],
    defaultVariant: "a",
    theme: {
      id: "family",
      className: "family"
    },
    getSteps: getFamilyDevotionalSteps
  }
];

export const FUNNEL_REGISTRY = FUNNEL_DEFINITIONS.reduce(
  (registry, definition) => ({
    ...registry,
    [definition.id]: definition
  }),
  {} as Record<FunnelId, FunnelDefinition>
);

const normalizeAlias = (value: string): string => {
  return value.toLowerCase().replace(/[^a-z0-9]/g, "_").replace(/^_+|_+$/g, "");
};

const FUNNEL_ALIAS_REGISTRY = FUNNEL_DEFINITIONS.reduce<Record<string, FunnelDefinition>>(
  (registry, definition) => {
    registry[normalizeAlias(definition.id)] = definition;
    registry[normalizeAlias(definition.slug)] = definition;

    for (const alias of definition.aliases) {
      registry[normalizeAlias(alias)] = definition;
    }

    return registry;
  },
  {}
);

export const getDefaultFunnel = (): FunnelDefinition => FUNNEL_REGISTRY[DEFAULT_FUNNEL_ID];

export const getFunnelById = (funnelId: FunnelId): FunnelDefinition => {
  return FUNNEL_REGISTRY[funnelId] ?? getDefaultFunnel();
};

export const resolveFunnelAlias = (value: string | null | undefined): FunnelDefinition | null => {
  if (!value) {
    return null;
  }

  return FUNNEL_ALIAS_REGISTRY[normalizeAlias(value)] ?? null;
};
